import UsersTable from '../../components/user/UsersTable';

const Users = () => <UsersTable />;
export default Users;
